import React from 'react';
import FoodIntakeRow from './FoodIntakeRow';
import FoodIntakeHeader from './FoodIntakeHeader';
import FoodIntakeFooter from './FoodIntakeFooter';

const FoodIntake = (props) => {
  const {output, data} = props;
  const {heading, footer} = props.data;

  return (
    <div className=" nppe2-fc-feeding-guidelines-food-intake" id="fc-screenshot-feeding-guidelines-food-intake">
      <div className="row">
      
        <div className="col-xs-12 nppe2-fc-sub-title-output">
          {heading}
        </div>

        <div className="col-xs-12">
          <table className='table nppe2-fc-feeding-guidelines-food-intake__table'>
            <tbody>

              <FoodIntakeHeader
                mealsPerDay={output.mealsPerDay}
                perDay={data.perDay}
                columns={data.columns}
              />

              {Array.from({ length: output.mealsPerDay }, (meal, key) =>
                <FoodIntakeRow
                  key={key}
                  columnIndex={key}
                  columns={new Array(data.columns.length).fill(null)}
                  meal={data.meal}
                />
              )}

              <FoodIntakeFooter
                total={data.total}
                columns={data.columns}
              />

            </tbody>
          </table>
        </div>

        <div className="col-xs-6 col-xs-push-6 text-right nppe2-fc-mt-1 nppe2-fc-feeding-guidelines-food-intake__label">
          {footer}
        </div>

      </div>
    </div>
  );
}

export default FoodIntake;
